export enum UserProfileTabsEnum {
    REVIEWS = "REVIEWS",
    COMPLETED_WORKS = "COMPLETED_WORKS",
    CREATED_WORKS = "CREATED_WORKS",
}
